export const invalidHouseNumber = ['number', 'near', 'range', 'street'];
